import { useEffect, useState } from 'react'
import apiFetch from '@wordpress/api-fetch'

export function useWpIsLoggedIn() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    let alive = true
    apiFetch({ path: '/users/me' })
      .then(() => alive && setIsLoggedIn(true))
      .catch(() => alive && setIsLoggedIn(false))

    return () => {
      alive = false
    }
  }, [])

  return isLoggedIn
}
